var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/* eslint-disable no-nested-ternary  */
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

var Wrapper = styled('li')(function (_ref) {
  var isOpen = _ref.isOpen,
      slideSpeed = _ref.slideSpeed,
      background = _ref.background,
      size = _ref.size,
      spacing = _ref.spacing,
      direction = _ref.direction;
  return {
    background: background,
    display: 'flex',
    border: 'none',
    borderRadius: '50%',
    boxShadow: '0 0 4px rgba(0,0,0,.14),0 4px 8px rgba(0,0,0,.28)',
    cursor: 'pointer',
    outline: 'none',
    padding: '0',
    WebkitUserDrag: 'none',
    fontWeight: 'bold',
    justifyContent: 'center',
    alignItems: 'center',
    opacity: isOpen ? 1 : 0,
    transition: 'all ' + slideSpeed + 'ms',
    width: size,
    height: size,
    marginTop: direction === 'down' ? spacing : 0,
    marginBottom: direction === 'up' ? spacing : 0,
    marginLeft: direction === 'right' ? spacing : 0,
    marginRight: direction === 'left' ? spacing : 0,
    pointerEvents: isOpen ? 'auto' : 'none'
  };
});

var ChildButton = function ChildButton(_ref2) {
  var _ref2$direction = _ref2.direction,
      direction = _ref2$direction === undefined ? 'up' : _ref2$direction,
      _ref2$index = _ref2.index,
      index = _ref2$index === undefined ? 1 : _ref2$index,
      _ref2$size = _ref2.size,
      size = _ref2$size === undefined ? '40' : _ref2$size,
      _ref2$spacing = _ref2.spacing,
      spacing = _ref2$spacing === undefined ? 0 : _ref2$spacing,
      _ref2$isOpen = _ref2.isOpen,
      isOpen = _ref2$isOpen === undefined ? false : _ref2$isOpen,
      _ref2$onClick = _ref2.onClick,
      onClick = _ref2$onClick === undefined ? null : _ref2$onClick,
      icon = _ref2.icon,
      rest = _objectWithoutProperties(_ref2, ['direction', 'index', 'size', 'spacing', 'isOpen', 'onClick', 'icon']);

  var offsetX = direction === 'right' ? (size + spacing) * index : direction === 'left' ? (size + spacing) * index * -1 : 0;
  var offsetY = direction === 'down' ? (size + spacing) * index : direction === 'up' ? (size + spacing) * index * -1 : 0;

  return React.createElement(
    Wrapper,
    _extends({
      isOpen: isOpen,
      size: size,
      spacing: spacing,
      direction: direction
    }, rest, {
      onClick: isOpen ? onClick : null,
      style: {
        transform: 'translate(' + (isOpen ? 0 : -offsetX) + 'px, ' + (isOpen ? 0 : -offsetY) + 'px)'
      }
    }),
    icon
  );
};

ChildButton.propTypes = {
  icon: PropTypes.node.isRequired,
  direction: PropTypes.string,
  index: PropTypes.number,
  onClick: PropTypes.func,
  isOpen: PropTypes.bool,
  size: PropTypes.number,
  spacing: PropTypes.number
};

export default ChildButton;